import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('modal');

    return {
        BACK_BUTTON_TEXT: t('backButtonText'),
        CONFIRMATION_TEXT: t('confirmationText'),
        DISCARD_BUTTON_TEXT: t('discardButtonText')
    };
};

export default useTranslation;
